export default __webpack_public_path__ + "media/sm_opportunity3_icon.c3bf311c9dccf9ea8f9977c03a320274.svg";